<div>
    <div class="dashboard__tile__title">
        <span>Work anniversaries: next 30 days</span>
    </div>
    <div
        class="dashboard__tile__content"
        *ngIf="!isLoading">
        <div class="table__overflow">
            <table
                mat-table
                [dataSource]="dataSource"
                matSort
                [hidden]="!(this.dataSource?.data?.length > 0)"
                matSortActive="daysUntilHired"
                matSortDirection="asc">
                <ng-container matColumnDef="firstName">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header>
                        The lucky one
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let row">
                        <app-pill-employee [employee]="row"></app-pill-employee>
                    </td>
                </ng-container>

                <ng-container matColumnDef="age">
                    <th
                        mat-header-cell
                        *matHeaderCellDef>
                        Years of service
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let row">
                        <span>{{ getEmployeeHiredYears(row) }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="daysUntilHired">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header>
                        Date
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let row">
                        <span *ngIf="row.daysUntilHired !== 0">{{ row.hireDate | amDateFormat: 'MMMM Do' }}</span>
                        <span *ngIf="row.daysUntilHired === 0">Today!</span>
                    </td>
                </ng-container>

                <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumns"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
    </div>

    <div
        class="dashboard__tile__content"
        *ngIf="this.noWorkAnniversaries && !isLoading">
        <app-message-empty
            [title]="'No upcoming anniversaries in the next 30 days...'"
            [icon]="'../../assets/img/open-box.png'"></app-message-empty>
    </div>

    <div *ngIf="isLoading">
        <app-loading-message></app-loading-message>
    </div>
</div>
